class NewMobile extends HTMLElement {
  constructor() {
    super();
    this.menuDrawerButtons = document.querySelectorAll("[data-drawer-trigger='menu-drawer']");

    this.nextMenu;

    this.navNextButtons = this.querySelectorAll('.new-mobile__next-button');

    this.closeBack = this.querySelector('.new-mobile__close-back');

    this.menuDrawerButtons.forEach(btn => {
      btn.addEventListener("click", () => this.toggleMenu(btn));
    })

    this.navNextButtons.forEach(nextBtn => {
      nextBtn.addEventListener("click", () => this.openNextNav(nextBtn));
    });

  }

  toggleMenu(btn) {
    if (btn.getAttribute('data-drawer-trigger') == 'menu-drawer') {
      this.classList.toggle("is-active");
      document.querySelector("body").classList.toggle("is-active");
    }

    if ((btn.getAttribute('data-drawer-trigger') == 'menu-next')) {
      this.closeNextNav();
    }
  }

  closeNextNav() {
    this.nextMenu.classList.remove("is-active");
    this.nextMenu = this.nextMenu.parentElement;
    if (this.nextMenu.parentElement.classList.contains('new-mobile__wrapper')) {
      this.closeBack.setAttribute('data-drawer-trigger', "menu-drawer");
      this.closeBack.innerHTML = `
      <svg class="icon icon--close" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g transform="rotate(-315 10 10)">
          <path fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="2.6" d="M10.093 22.476L10.09-1.94"></path>
          <path fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="2.6" d="M22.476 10.333l-24.416.002"></path>
        </g>
      </svg>
        `;
    }
  }

  openNextNav(nextBtn) {
    this.nextMenu = nextBtn.nextElementSibling;
    this.closeBack.setAttribute('data-drawer-trigger', "menu-next");
    this.closeBack.innerHTML = `
      <svg class="new-mobile__back" height="36" viewBox="0 0 36 36" width="36" xmlns="http://www.w3.org/2000/svg" class="icon back-arrow">
        <path d="m16.9659864 24.9319728 1.1972789-1.1972789-4.9290573-4.9135083h12.765792v-1.7103984h-12.765792l4.9290573-4.9290574-1.1972789-1.1817298-6.9659864 6.9659864z"></path>
      </svg>
      `;
    this.nextMenu.classList.add("is-active");
  }
}

customElements.define("new-mobile", NewMobile);